export interface IPlanCategory {
  id?: number;
  planCategory?: string;
}

export const defaultValue: Readonly<IPlanCategory> = {};
